<div
  [attr.id]="module.finalSlug || null"
  [attr.data-ancnav]="module.finalSlug || null"
  class="content-module video-module"
  [attr.data-show-player]="isShowPlayer"
>
  <svg class="video-module__sticker" (click)="showPlayer()">
    <use xlink:href="#sticker--play" />
  </svg>
  <div class="video-module__inner">
    <img
      [src]="thumbnail.url"
      [alt]="thumbnail.alt"
      class="video-module__thumbnail"
      (click)="showPlayer()"
    >
    <div [id]="videoDomId" class="video-module__iframe"></div>
  </div>
</div>
